import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Venice, FL?",
    a: "Our fastest service processes passports in as little as 24–72 hours. Rush processing takes 4–7 business days, and standard expedited service takes 2–3 weeks. The speed you choose depends on your travel date and urgency — whether it is a theatre tour to London in three weeks or an emergency flight to Toronto in three days.",
  },
  {
    q: "Where is the closest passport acceptance facility to Venice?",
    a: "The closest facility is USPS Venice at 333 W Venice Ave in historic downtown Venice. Other nearby options include USPS Sarasota Main (~30–35 min north via US-41), USPS North Port (~15–20 min east via US-41), USPS Englewood (~20–25 min south via US-41), and Sarasota County Clerk in downtown Sarasota (~30–35 min north). All require appointments for passport services.",
  },
  {
    q: "Do I need a passport to cruise from Tampa if I live in Venice?",
    a: "Yes. All Caribbean and international cruises from Port Tampa Bay require a valid U.S. passport for every passenger, including children. Even closed-loop cruises that start and end at the same U.S. port strongly recommend carrying a passport in case you need to fly home from a foreign port due to illness, injury, or emergency.",
  },
  {
    q: "Can I renew my passport by mail, or do I need to visit an acceptance facility?",
    a: "If your most recent passport was issued when you were 16 or older, is undamaged, was issued within the last 15 years, and was in your current name (or you have legal documentation of a name change), you can renew by mail using Form DS-82 — no acceptance facility visit needed. Otherwise, you need Form DS-11 and an in-person visit.",
  },
  {
    q: "What is the child passport trap?",
    a: "Child passports (for applicants under 16) are only valid for 5 years. Many parents and grandparents forget this shorter validity period and discover their child's passport has expired right before a family trip. The child must also appear in person with both parents (or proper consent documentation) for every application.",
  },
  {
    q: "Do I need six months of passport validity for Caribbean cruises?",
    a: "Yes. Most Caribbean cruise lines and island nations require your passport to be valid for at least six months beyond your return date. Do not assume your passport is fine just because it has not expired — check the specific validity requirements for every destination on your itinerary.",
  },
  {
    q: "Can Fast Passport Center take my passport photo?",
    a: "We provide detailed guidance on State Department photo requirements and can direct you to approved photo partners in Sarasota County — including locations on Venice Avenue, in Sarasota, and in North Port. The photo must be 2×2 inches, taken against a white or off-white background, with a neutral expression and no glasses.",
  },
  {
    q: "What if my passport was damaged by humidity in my Venice home?",
    a: "Humidity damage is common in Florida's Gulf Coast climate. Water damage, salt air exposure, mold, separating bindings, or any physical compromise invalidates a passport. If your passport shows any damage from Florida's climate — even if the data page is still readable — it must be replaced immediately using Form DS-11 with an acceptance facility visit.",
  },
  {
    q: "I have a non-refundable spring break package to Cancun. How do I make sure my passport is valid?",
    a: "Mexico requires your passport to be valid for at least six months beyond your departure date. All-inclusive resort packages are typically non-refundable within 30–60 days of departure. Check your family's passport expiration dates before booking, and start renewals at least 6–8 weeks before departure.",
  },
  {
    q: "What forms of payment do you accept?",
    a: "We accept all major credit cards, debit cards, and bank transfers. Government fees are paid separately via check or money order made payable to the U.S. Department of State, as required by federal regulations.",
  },
  {
    q: "Do you offer any guarantees?",
    a: "We guarantee that your application will be submitted correctly and tracked throughout processing. If a delay occurs due to an error we should have caught, we work to resolve it at no additional charge. Travel is inherently unpredictable, but our track record with Southwest Florida clients — including Venice retirees, snowbirds, theatre travelers, and spring break families — speaks for itself.",
  },
  {
    q: "How do I get my documents to you from Venice?",
    a: "We arrange secure document pickup through our courier network or provide prepaid overnight shipping labels for Sarasota County residents. Your documents are insured, tracked, and handled by bonded couriers from pickup through delivery of your completed passport — whether you are at your Venice Golf & Country Club home, your condo near the beach, or your seasonal rental.",
  },
];

export default function VeniceFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Frequently Asked Questions
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Questions — Venice, FL
          </h2>
          <p className="text-gray-600 text-sm md:text-base">
            Quick answers to the most common questions from Venice and Sarasota County travelers.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-lg transition-all ${openIndex === i ? "border-[#F6C344] bg-[#FFF8E7]/30" : "border-gray-200 bg-white hover:border-gray-300"}`}
            >
              <button
                className="w-full flex items-start justify-between gap-4 p-5 text-left"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm">{faq.q}</span>
                <i
                  className={`ri-arrow-down-s-line text-[#F6C344] text-lg shrink-0 transition-transform ${openIndex === i ? "rotate-180" : ""}`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}